import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const MenuPopoverRow = ({ children, className, ...otherProps }) => {
  const classes = ["menuPopoverRow", className || ""].join(" ");
  return (
    <div className={classes} {...otherProps}>
      {children}
    </div>
  );
};

MenuPopoverRow.propTypes = {
  children: PropTypeShapes.elementOrArrayOrString.isRequired,
  className: PropTypes.string
};

export default MenuPopoverRow;
